import { render, staticRenderFns } from "./ChooseAvatar.vue?vue&type=template&id=d685b708&scoped=true&"
import script from "./ChooseAvatar.vue?vue&type=script&lang=js&"
export * from "./ChooseAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d685b708",
  null
  
)

export default component.exports